import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[headerSection]',
    standalone: true
})
export class HeaderSectionDirective {

  constructor(
    public viewContainerRef: ViewContainerRef
  ) { }

}
